export const MONDAY_FIRST_WEEKDAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export const MONTH_I18N_KEYS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
] as const;

export type RosterDateLabelTranslator = (key: string) => string;

export const getMondayWeekdayLabelsLocalized = (t: RosterDateLabelTranslator): string[] => (
  MONDAY_FIRST_WEEKDAY_KEYS.map((key) => t(`weekdays.${key}`))
);

export const formatMonthYearLabel = (date: Date, t: RosterDateLabelTranslator): string => {
  const monthKey = MONTH_I18N_KEYS[date.getMonth()];
  return `${t(`months.${monthKey}`)} ${date.getFullYear()}`;
};

export const formatCompactWeekRangeLocalized = (
  weekStart: Date,
  weekEnd: Date,
  t: RosterDateLabelTranslator,
): string => {
  const sameMonth = weekStart.getMonth() === weekEnd.getMonth()
    && weekStart.getFullYear() === weekEnd.getFullYear();
  const monthShort = (date: Date) => t(`monthsShort.${MONTH_I18N_KEYS[date.getMonth()]}`);

  if (sameMonth) {
    return `${weekStart.getDate()} – ${weekEnd.getDate()} ${monthShort(weekEnd)}`;
  }

  return `${weekStart.getDate()} ${monthShort(weekStart)} – ${weekEnd.getDate()} ${monthShort(weekEnd)}`;
};

export const formatMonthDayColumnLabel = (
  date: Date,
  weekdayIndex: number,
  t: RosterDateLabelTranslator,
): string => {
  const weekdayKey = MONDAY_FIRST_WEEKDAY_KEYS[weekdayIndex];
  return `${t(`weekdays.${weekdayKey}`)} ${date.getDate()}`;
};

export const formatWeekDayColumnLabel = (
  date: Date,
  weekdayIndex: number,
  t: RosterDateLabelTranslator,
): string => {
  const weekdayKey = MONDAY_FIRST_WEEKDAY_KEYS[weekdayIndex];
  const monthKey = MONTH_I18N_KEYS[date.getMonth()];
  return `${t(`weekdays.${weekdayKey}`)}, ${date.getDate()} ${t(`monthsShort.${monthKey}`)}`;
};

export const formatWeekDayShortLabel = (
  date: Date,
  weekdayIndex: number,
  t: RosterDateLabelTranslator,
): string => {
  const weekdayKey = MONDAY_FIRST_WEEKDAY_KEYS[weekdayIndex];
  return `${t(`weekdaysLong.${weekdayKey}`)}, ${date.getDate()}`;
};
